module.exports = __webpack_public_path__ + "img/align-horizontal-right.dfbd53eb.svg";